module.exports = __webpack_public_path__ + "img/38.1863537b.jpg";